module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Bold_201015-c55a07308a3fca43405e07ec4a3230fe.ttf";